import { Component, effect, inject, input, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button'
import { MatTableModule, MatRow, MatTableDataSource } from '@angular/material/table'
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule, MatSort } from '@angular/material/sort';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDialog } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatCardModule } from '@angular/material/card';
import { MatMenuModule } from '@angular/material/menu';
import { MatCheckbox } from '@angular/material/checkbox'


import { DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { NgFor, NgIf } from '@angular/common';
import { style, state, trigger, transition, animate } from '@angular/animations';
import { FeedstockService } from '../../../services/feedstockservice';
import { FilterState, GeneratorsList } from '../../../interfaces/generatorsmodel';
import { MarketmDialogComponent } from '../../markets/market-dilaog/market-dialog.component';
import { AddeditGeneratorComponent } from './addedit-generator/addedit-generator.component';
import { ConfirmationDialogComponent, ConfirmationDialogData } from '../../shared/components/confirmation-dialog/confirmation-dialog.component';
import { NotificationService } from '../../../services/notificationservice';
import { RolePermissionsService } from '../../../services/role-permissions.service';
import { RoleService } from '../../../services/role.service';
import { LoadScheduleControlFlags, ScreenName } from '../../../interfaces/securityPermissions';

@Component({
  selector: 'app-generators',
  standalone: true,
  imports: [MatIcon, MatTableModule, MatRow, MatPaginatorModule, MatSortModule, MatFormFieldModule,
    MatInputModule, MatButtonModule, MatSelectModule, MatDatepickerModule,
    MatMenuModule, MatProgressBarModule, MatProgressSpinnerModule, MatCardModule],
  templateUrl: './generators.component.html',
  styleUrl: './generators.component.scss',
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ]
})
export class GeneratorsComponent implements OnInit {
  displayedColumns: string[] = ['actions', 'id','generatorName', 'contactName', 'contactEmail', 'contactPhone',
    'lgX_ContactName', 'lgX_ContactEmail', 'lgX_ContactPhone', 'accountNumber' , 'siteNumber', 'marketName',
    'environment_Fee_FlagDescription', 'isTipFeeRequiredDescription', 'isVRSiteDescription'];
  permissions = inject(RolePermissionsService);
  dataSource = new MatTableDataSource<any>;
  generatorList: GeneratorsList[] = [];
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;  
  filterState = input<FilterState | null>(null);
  refreshTrigger = input<number>(0);
  gridSearchText = input<string | null>(null);
  controlPermissions: LoadScheduleControlFlags = new LoadScheduleControlFlags();
    
  constructor(private _dialog: MatDialog, private fsService: FeedstockService,
    private notificationService: NotificationService, private rolesService: RoleService
   ) {
    effect(() => {
      const currentFilter = this.filterState();
      const trigger = this.refreshTrigger();
      const marketId = currentFilter?.market?.toString() || '-1';
      //console.log(`Generators: Fetching data. Trigger: ${trigger}, Market: ${marketId}`);
      this.getGenerators(marketId);
    });
    
    effect(() => {
      const searchText = this.gridSearchText();
      if (this.dataSource) { 
        //console.log(`Generators Component: Applying filter for search text: ${searchText}`);
        this.applyGridFilter(searchText ?? '');
      }
    });
  }
  
  ngOnInit(): void {
  }

  triggerError() {
    throw new Error('This is a test error');
  }

  getGenerators(marketId: string){
    let roles = this.rolesService.getRolesAsString();
    this.permissions.getRolePermissionsNew(roles, ScreenName.CustomerInfo, 0).subscribe({
      next: (perms: LoadScheduleControlFlags) => {
        this.controlPermissions = perms;
      }
    })
    this.fsService.getGeneratorList(marketId).subscribe({
      next: (res: GeneratorsList[]) => {
        console.log("gen data:", res);
        this.generatorList = res;
        this.dataSource = new MatTableDataSource(this.generatorList);
        
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;

        const currentSearchText = this.gridSearchText();
        if (currentSearchText) {
            this.applyGridFilter(currentSearchText);
        }
      }
    });
  }

  openAddEditForm(data: GeneratorsList | null, task: string) {
    const dialogRef = this._dialog.open(AddeditGeneratorComponent, {
      data: {
        data: data,
        canSave: this.controlPermissions.editCustomer
      },
      disableClose: true,
      width: '1000px',
      maxWidth: '1050px',
      maxHeight: '90vh'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        const marketId = this.filterState()?.market?.toString() || '-1';
        this.getGenerators(marketId);
        this.notificationService.show(`Data ${task === 'add' ? 'added' : 'updated'} successfully`, 'Success');
      }
    });
  }
  
  deleteGenerator(id: number, name: string){
    const dialogData: ConfirmationDialogData = {
      title: 'Confirm Deletion',
      message: `Are you sure you want to delete Generator ${name}?`,
      confirmButtonText: 'Delete',
      cancelButtonText: 'Cancel',
      confirmButtonColor: 'warn'
    };

    this._dialog.open(ConfirmationDialogComponent, {
      width: '400px',
      panelClass: 'delete-confirmation-dialog',
      data: dialogData,
      disableClose: true,
    }).afterClosed().subscribe(result => {
      if (result) {
        if (id !== null && id !== undefined) {
          this.fsService.deleteCustomer(id).subscribe({
            next: () => {
              this.dataSource.data = this.dataSource.data.filter(item => item.id !== id);
              this.notificationService.show(`Data deleted successfully`, 'Success');
            }
          });
        }
      }
    });
  }

  applyGridFilter(filterText: string) {
    console.log("grid search fired", filterText);
    const filterValue = filterText.trim().toLowerCase();
    this.dataSource.filter = filterValue;
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  openContextmenu(data: any) {

  }
}

